import type { HttpTypes } from '@medusajs/types';

export function isPriceFiltered(min?: number, max?: number): boolean {
  return min !== undefined || max !== undefined;
}

export function filterProductsByPrice(
  products: HttpTypes.StoreProduct[],
  minPrice?: number,
  maxPrice?: number,
): HttpTypes.StoreProduct[] {
  if (minPrice === undefined && maxPrice === undefined) {
    return products;
  }

  return products.filter((product) => {
    if (!product.variants?.length) return false;

    type VariantWithPrice = HttpTypes.StoreProductVariant & {
      calculated_price?: { calculated_amount: number };
    };

    const prices = product.variants
      .filter(
        (v) =>
          (v as VariantWithPrice)?.calculated_price?.calculated_amount != null,
      )
      .map(
        (v) =>
          (v as VariantWithPrice).calculated_price?.calculated_amount as number,
      );

    if (prices.length === 0) return false;

    const cheapest = Math.min(...prices);

    if (minPrice !== undefined && cheapest < minPrice) return false;
    if (maxPrice !== undefined && cheapest > maxPrice) return false;

    return true;
  });
}
